import { appstore, googleplay } from '@/utils/imagepath';
import { routePrefix, routes } from '@/utils/routes/routes';
import React from 'react';
import { useNavigate } from 'react-router';

const HomePageFooter = ({ themeData }: any) => {
  const navigate = useNavigate();

  const navigateToPricing = () => {
    navigate(routes.pricing);
  };

  return (
    <div style={{ width: '100vw' }}>
      <section className="our-service-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center aos-init mb-5"
                data-aos="zoom-in-up"
              >
                <h2>{themeData?.theme_5?.home?.section_our_services?.title}</h2>
              </div>
            </div>
          </div>
          <div className="our-service-inner aos-init" data-aos="zoom-in-up">
            <div className="our-service-wrapper">
              <div className="row">
                {themeData?.theme_5?.home?.section_our_services?.service_section.services.map(
                  (item: any) => {
                    return (
                      <>
                        <div className="col-md-4 d-flex col-sm-6">
                          <div className="service-widget flex-fill" style={{ backgroundColor: item?.bg_color ? `#${item?.bg_color}` : '' }}>
                            <div className="services-img">
                              <img
                                src={item.service_image}
                                alt=""
                                className="img-fluid"
                              />
                            </div>
                            <h4
                              style={{
                                color: item?.color ? `#${item?.color}` : '',
                                cursor: item?.service_link ? 'pointer' : 'default'
                              }}
                              onClick={() => item?.service_link && navigate(`${routePrefix}${item?.service_link}`)}
                            >
                              {item.service_title}
                            </h4>
                            <p style={{ color: item?.color ? `#${item?.color}` : '' }}>{item.service_description}</p>
                            <span style={{ color: item?.color ? `#${item?.color}` : '' }}>{item.service_text}</span>
                          </div>
                        </div>
                      </>
                    );
                  }
                )}

              </div>
              <div className="view-price">
                <button
                  type="button"
                  className="btn btn-primary hover-btn"
                  style={{
                    background: `#${themeData?.theme_5?.home?.section_our_services?.btn_group?.btn1?.bg_color}`,
                    color: `#${themeData?.theme_5?.home?.section_our_services?.btn_group?.btn1?.color}`,
                  }}
                  onClick={navigateToPricing}
                >
                  {
                    themeData?.theme_5?.home?.section_our_services?.btn_group
                      ?.btn1?.text
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div
        className="wash-fold-section"
        style={{
          background: `var(--primary-color) url(${themeData?.theme_5?.home?.section_5?.banner}) no-repeat top center`,
        }}
      >
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="wash-fold-card">
                <div className="wash-fold-text">
                  <h2
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_5?.h2color}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_5?.title}
                  </h2>
                  {/* <h2>WASH <br />& <br/> FOLD</h2> */}
                </div>
                <div className="wash-fold-info">
                  <ul>
                    {themeData?.theme_5?.home?.section_5?.wash_title?.map(
                      (item: any) => {
                        return (
                          <>
                            <li>
                              <i className="fa fa-check"></i>{' '}
                              <p
                                style={{
                                  color: `#${themeData?.theme_5?.home?.section_5?.paracolor}`,
                                }}
                              >
                                {item?.wash_list}
                              </p>
                            </li>
                          </>
                        );
                      }
                    )}
                    {/* <li><i className="fa fa-check"></i> <p>Washed under <span className=''>30 degrees</span></p></li>
                                        <li><i className="fa fa-check"></i> <p>Dried at <span className=''>medium heat</span></p></li>
                                        <li><i className="fa fa-check"></i> <p>Customer’s responsibility to <span className=''>make sure all items are washable</span></p></li>
                                        <li><i className="fa fa-check"></i><span> <p><span className=''>Towels and beddings</span> are  excluded and will be charged separately.</p></span></li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section
        className="aboutsec"
        style={{
          background: `#${themeData?.theme_5?.home?.section_6?.background_image_color} url("assets/img/about-section/about-bg.png") no-repeat`,
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-6 d-none d-md-block">
              <div className="about-img-left aos-init" data-aos="zoom-in-up" style={themeData?.theme_5?.home?.section_6?.section_image && { background: `url(${themeData?.theme_5?.home?.section_6?.section_image})` }}>
                {/* {themeData?.theme_5?.home?.section_6?.section_image && (
                  <img
                    src={themeData?.theme_5?.home?.section_6?.section_image}
                    className="img-fluid aos-init"
                    alt="About US"
                    data-aos="zoom-in-up"
                  />
                )} */}
              </div>
            </div>
            <div className="col-lg-6">
              <div
                className="about-content-right aos-init"
                data-aos="zoom-in-up"
              >
                <div className="section-title">
                  <h2
                    className="text-start section-title-h2"
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_6?.h2color}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_6?.title}
                  </h2>
                  <h2
                    className="section-title-head"
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_6?.h3color}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_6?.sub_heading}
                  </h2>
                </div>

                <p
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_6?.paracolor}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_6?.paragraph}
                </p>
                <div className="about-icon">
                  <div className="row">
                    {themeData?.theme_5?.home?.section_6?.card_section.collection.map(
                      (item: any) => {
                        return (
                          <>
                            <div className="col-lg-6 col-md-6">
                              <div className="media d-flex">
                                {item.collection_image && (
                                  <img
                                    src={item.collection_image}
                                    alt="About Icon"
                                  />
                                )}
                                <div className="media-body flex-grow-1">
                                  <h5
                                    style={{
                                      color: `#${themeData?.theme_5?.home?.section_6?.paracolor}`,
                                    }}
                                  >
                                    {item.collection_title}
                                  </h5>
                                  <p
                                    style={{
                                      color: `#${themeData?.theme_5?.home?.section_6?.paracolor}`,
                                    }}
                                  >
                                    {item.collection_paragraph}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="easelaundry-wrapper">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div
                className="easelaundry-img-right aos-init"
                data-aos="zoom-in-up"
              >
                {themeData?.theme_5?.home?.section_7?.banner && (
                  <img
                    src={themeData?.theme_5?.home?.section_7?.banner}
                    className="img-fluid aos-init"
                    alt="Ease to Made Laundry"
                    data-aos="zoom-in-up"
                  />
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div
                data-aos="zoom-in-up"
                className="easelaundry-content-left text-start aos-init"
              >
                <div className="section-title text-start">
                  <h2
                    className="text-start"
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_7?.h2color}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_7?.title}
                  </h2>
                </div>
                <div className="">
                  <p
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_7?.paragraph1}
                  </p>

                  <p
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_7?.paragraph2}
                  </p>
                  <ul>
                    {themeData?.theme_5?.home?.section_7?.card_section?.map(
                      (items: any, index: any) => {
                        return (
                          <>
                            <li
                              style={{
                                color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                              }}
                            >
                              {index + 1} : {items.text}
                            </li>
                          </>
                        );
                      }
                    )}
                  </ul>
                  <p
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_7?.paragraph3}
                  </p>

                  <p
                    style={{
                      color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                    }}
                  >
                    {themeData?.theme_5?.home?.section_7?.paragraph4}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="section-app app-download-blk"
        style={{
          background: `#${themeData?.theme_5?.home?.section_8?.bg_color}`,
        }}
      >
        <div className="container">
          <div className="row">
            <div className="app-content col-md-6 aos-init" data-aos="zoom-in-up">

              <h2 style={{
                color: `#${themeData?.theme_5?.home?.section_8?.h2color}`
              }}>{themeData?.theme_5?.home?.section_8?.title}</h2>
              <p style={{
                color: `#${themeData?.theme_5?.home?.section_8?.paracolor}`
              }}>{themeData?.theme_5?.home?.section_8?.paragraph}</p>
              <ul className="pt-5">
                <li>
                  <a
                    target="_blank"
                    className="hvr-float-shadow imggbg"
                    href={
                      themeData?.theme_5?.home?.section_8?.mobile_link_section
                        ?.ios_link
                    }
                  >
                    <img
                      src={appstore}
                      alt="appstore"
                      className="img img-fluid"
                    />
                  </a>
                </li>
                <li>
                  <a
                    target="_blank"
                    className="hvr-float-shadow imggbg2"
                    href={
                      themeData?.theme_5?.home?.section_8?.mobile_link_section
                        ?.android_link
                    }
                  >
                    <img
                      src={googleplay}
                      alt="appstore"
                      className="img img-fluid"
                    />
                  </a>
                </li>
              </ul>
            </div>
            <div className="app-img col-md-6">
              <img
                src={themeData?.theme_5?.home?.section_8?.banner}
                className="img-fluid aos-init"
                alt="appdownload"
                data-aos="zoom-in-up"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageFooter;
